module.exports = __webpack_public_path__ + "static/img/zhizhao.22b0130.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/zhizhao.jpg
// module id = dEZh
// module chunks = 0